import React from "react";
import IndexImage from "../../assets/images/large_logo.png";
import Index from "../../assets/images/index.png";
import { Navbar, Nav } from "react-bootstrap";
import "./header.css";

const Header = () => {
  return (
    <>
      <div className="top_contents">
        <div className="content_left">
          <img src={IndexImage} alt="logo" />
        </div>
        <div className="content_right">
          <img src={Index} alt="logo" style={{ height: "80px" }} />
        </div>
      </div>
      <Navbar expand="lg" style={{ backgroundColor: "green" }}>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="mr-auto">
            <Nav.Link href="/" className="space">
              <div className="contents">Home</div>
            </Nav.Link>
            <Nav.Link href="/products" className="space">
              <div className="contents">Products</div>
            </Nav.Link>
            <Nav.Link href="/jobs" className="space">
              <div className="contents">Jobs</div>
            </Nav.Link>
            <Nav.Link href="/about-us" className="space">
              <div className="contents">Services</div>
            </Nav.Link>
            <Nav.Link href="/contact-us" className="space">
              <div className="contents">Contact Us</div>
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    </>
  );
};

export default Header;
